import { memo } from "react";

import { Separator } from "@/components/ui/separator";

const Introduction = memo(() => {
  return (
    <>
      <div className="flex flex-col items-center justify-center text-center">
        <h1 className="text-xl md:text-3xl font-semibold text-primary">
          Synthetic Personas
        </h1>
        <p className="text-base md:text-lg">
          Interact with personas representing members and potential members
        </p>
        <p className="text-xs md:text-sm text-muted-foreground">
          This is one of several Al-first projects of the ATC Venture Studio's
          Greenhouse
        </p>
      </div>
      <Separator className="my-8" />
    </>
  );
});

export { Introduction };
